'use client';

class ManagedTimeout {
  timeout = null;
  lastTimeoutStart = Date.now();
  remainingMs;
  callback;
  constructor(remainingMs, callback) {
    this.remainingMs = remainingMs;
    this.callback = callback;
  }
  pause() {
    if (!this.timeout) return;
    this.remainingMs -= Date.now() - this.lastTimeoutStart;
    this.timeout = (this.timeout && clearTimeout(this.timeout)) ?? null;
  }
  resume() {
    if (this.timeout) return;
    this.timeout = setTimeout(this.callback, this.remainingMs);
    this.lastTimeoutStart = Date.now();
  }
}
export {
  ManagedTimeout
};
